import _ from 'lodash'
import unwrapModel from 'scoreboard/components/unwrap-model'
import conductor from 'scoreboard/components/conductor'

/**
 * @enum {string}
 */
const LegendLocation = {
	CHART_TITLE: 'chart-title',
	BESIDE_CHART: 'beside-chart',
	DASHBOARD_WIDGET: 'dashboard-widget',
}

/**
 * Indicates whether the color legend should be rendered according to the
 * chart's settings and where we are intending to render the legend.
 *
 * @param {ChartDesigner} chart the ChartDesigner model for the current chart
 *
 * @param {LegendLocation} legendLocation indicates where we are intending to
 * render the legend
 */
function shouldRenderLegend(chart, legendLocation) {
	// #60159 we generally don't render the legend if there's an error on the
	// chart, but we *do* render it if the legend is a dashboard widget (we just
	// render it in an error state)
	if (legendLocation !== DASHBOARD_WIDGET && chart.hasError()) {
		return false
	}
	const isSinglePeriod = chart.isSinglePeriod() || !chart.isRepeating()
	const series = chart.getSerieFeatures()
	chart = unwrapModel(chart)

	if (_.isEmpty(chart.legends)) return false

	const legendType = conductor.section() === 'scorecards' ? 'chart-title' :
		chart.legends[0].legendType

	if (legendType === 'none' ||
		(legendLocation === CHART_TITLE && legendType !== 'chart-title') ||
		(legendLocation !== CHART_TITLE && legendType === 'chart-title')) {
		return false
	}

	if (chart.plotType === 'filled-map') return true

	if (legendType === 'auto') {
		const isBar = chart.plotType === 'bar'
		const seriesLabels = !_.isEmpty(chart.labels) &&
			_.some(chart.labels, l => !!l.seriesLabels)

		if ((isBar && isSinglePeriod && chart.xaxisLabels) ||
			chart.chartTable || seriesLabels) {
			return false
		}
	}
	return series && series.length > 1
}

export default shouldRenderLegend
export const CHART_TITLE = LegendLocation.CHART_TITLE
export const BESIDE_CHART = LegendLocation.BESIDE_CHART
export const DASHBOARD_WIDGET = LegendLocation.DASHBOARD_WIDGET

shouldRenderLegend.__filename__ = 'charts/should-render-legend.js'
